export const CONDITION_OPERATORS = [
  {
    value: 'AND',
    label: 'AND',
  },
  {
    value: 'OR',
    label: 'OR',
  },
];
